import { useRef, useMemo } from "react";
function setRef(ref, instance) {
  if (ref) {
    if (typeof ref === "function") {
      ref(instance);
    } else if (instance) {
      ref.current = instance;
    }
  }
}
function useComposeRef(...refs) {
  const initialRefs = useRef(refs);
  const composeRef = useMemo(() => {
    function composedRefCallback(instance) {
      initialRefs.current.forEach((ref) => setRef(ref, instance));
      setCurrent(instance);
    }
    function setCurrent(instance) {
      if (instance) {
        composedRefCallback.current = instance;
      }
    }
    composedRefCallback.current = null;
    return composedRefCallback;
  }, []);
  return composeRef;
}
export {
  useComposeRef
};
//# sourceMappingURL=useComposeRef.js.map
